import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    title: {
        fontSize: "1.4rem"
    },
    paper: {
        margin: "10px"
    },
    pagination: {
        "& .MuiTypography-body2": {
            marginBottom: "0rem",
            fontSize: "1rem"
        }
    },
    tableHead: {
        "& .MuiTableCell-head": {
            fontSize: "1rem"
        }
    },
    tableMessagePlaceholder: {
        textAlign: "center"
    },
    initialMessageText: {
        fontSize: "inherit"
    },
    errorMessageText: {
        fontSize: "inherit",
        color: "red"
    },
    emptyResultsMessageText: {
        fontSize: "inherit",
        color: "green"
    },
    progressBar: {
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#3474b4"
        }
    },
    downloadCapturesIcon: {
        color: "#3474b4"
    },
    flow: {
        flexGrow: 1
    },
    metadataText: {
        "& .MuiButton-root" : {
            fontWeight: 400,
            textTransform: "lowercase"
        },
        padding: 0,
        textDecoration: "underline",
        color: "#3474b4"
    },
    metadataButton: {
        color: "#3474b4"
    }
});
